export default __webpack_public_path__ + "static/media/main_visual.bea7eaf1.webp";